export default {
  namespaced: true,
  state: {
    isOpenTag: false,
    size: 10, // 分页 页大小
    token: "",
    resetCode: null,
    appLoading: false,
    resetPassword: false,
    setNewOpen: {
      title: "",
      href: ""
    }
  },
  mutations: {
    OPEN_TAG: (state, data) => {
      state.setNewOpen = data;
      state.isOpenTag = true;
    },
    CLOSE_TAG: state => {
      // state.openTag = action;
      state.isOpenTag = false;
    },
    // 设置分页大小
    SET_PAGE_SIZE(state, data) {
      state.size = data;
    },
    // 设置token
    SET_TOKEN(state, data) {
      state.token = data;
    },
    // 设置token
    SET_CODE(state, data) {
      state.resetCode = data;
    },
    // 设置是否加载中
    SET_LOADING: (state, loading) => {
      state.appLoading = loading;
    },
    // 设置是需呀重置密码
    SET_RESETPWD: (state, data) => {
      state.resetPassword = data;
    }
  },
  actions: {
    //跳转打开tag
    setOpenTag({ commit }, data) {
      commit("OPEN_TAG", data);
    },
    // 设置分页大小
    setPageSize({ commit }, data) {
      commit("SET_PAGE_SIZE", data);
    },
    // 设置token
    setToken({ commit }, data) {
      commit("SET_TOKEN", data);
    },
    // 设置token
    setCode({ commit }, data) {
      commit("SET_CODE", data);
    },
    // 显示应用加载进度条
    setLoading({ commit }, data) {
      commit("SET_LOADING", data);
    },
    // 打开修改密码框
    setPassword({ commit }, data) {
      commit("SET_RESETPWD", data);
    }
  }
};
